
























import { Component, Prop, Watch, Vue } from 'vue-property-decorator'

function arraysEqual (a: any[], b: any[]) {
  if (a === b) return true
  if (a == null || b == null) return false
  if (a.length !== b.length) return false

  for (var i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) return false
  }
  return true
}

@Component
export default class TextInput extends Vue {
  @Prop({ type: Boolean, default: false }) placesEnabled: boolean // whether google places autocomplete is turned on for this field
  @Prop({ default: 'text' }) type!: string
  @Prop({ type: Boolean, default: false }) required: boolean
  @Prop({ type: Boolean, default: false }) numpad: boolean
  @Prop({ type: Function, default: () => {} }) onEnterKey: Function
  @Prop() name!: string
  @Prop() label!: string
  @Prop() value: string
  @Prop() autocomplete: string

  hint: string = 'init error hint'
  invalid: boolean = false
  focussed: boolean = false
  success: boolean = false
  googlePoll: number
  googleAutocomplete: any
  gmapsLoaded: boolean = false

  get auto () {
    if (!this.autocomplete) return null
    if (this.name === 'address_1' && !this.focussed) return 'address-line1'
    // if the prop is placesEnabled, we turn on google's places api
    // but if the field doesn't have focus, just turn it on (like if they enter their name first)
    if (this.name === 'address_1' && this.focussed) return 'disabled'
    return this.autocomplete
  }

  mounted () {
    // set up poll for google maps to add autocomplete
    if (this.placesEnabled) {
      this.googlePoll = setInterval(this.mapsCallback, 150)
    }
  }

  @Watch('value')
  handleValueChange (val: string) {
    if (val) {
      this.invalid = false
      this.success = true
    }
  }

  mapsCallback () {
    if (window.google && window.google.maps) {
      window.clearInterval(this.googlePoll)

      this.gmapsLoaded = true

      let streetNumber: string
      let route: string
      let city: string
      let state: string
      let zip: string
      let country: string

      // eslint-disable-next-line
      this.googleAutocomplete = new window.google.maps.places.Autocomplete( this.$refs.input, { types: ['geocode'] } )
      this.googleAutocomplete.addListener('place_changed', () => {
        const place = this.googleAutocomplete.getPlace()
        console.log('place', place)
        // I guess build an Address object?
        if (place && place.address_components) {
          place.address_components.forEach(({ short_name, types }: { short_name: string, types: string[] }) => {
            if (arraysEqual(types, ['street_number'])) {
              streetNumber = short_name
            } else if (arraysEqual(types, ['route'])) {
              route = short_name
            } else if (arraysEqual(types, ['locality', 'political']) || arraysEqual(types, ['sublocality_level_1', 'sublocality', 'political'])) {
              city = short_name
            } else if (arraysEqual(types, ['administrative_area_level_1', 'political'])) {
              state = short_name
            } else if (arraysEqual(types, ['postal_code'])) {
              zip = short_name
            } else if (arraysEqual(types, ['country', 'political'])) {
              country = short_name
            }
          })

          const address: GooglePlace = {
            streetNumber,
            route,
            city,
            state,
            zip,
            country,
          }

          this.$emit('googlePlaceChange', address)
        }
      })
    }
  }

  get errorHint () {
    return `Invalid ${this.label}`
  }

  validate ($event: any) {
    const val = $event.target.value
    this.invalid = ((this.required && val === '') || !$event.target.validity.valid)
    this.$emit('input', val)
    this.success = !this.invalid
  }

  setFocus () {
    this.focussed = true
  }

  setBlur ($event: any) {
    const val = $event.target.value
    this.invalid = this.required && val === ''
    this.focussed = false
    this.success = !this.invalid
    this.$emit('blur', this.name, $event.target.value)
  }
}
